module.exports = __webpack_public_path__ + "img/winery.50c33702.jpg";